import { render } from "./ReferencesSection.vue?vue&type=template&id=0548492d&scoped=true&lang=true"
import script from "./ReferencesSection.vue?vue&type=script&lang=js"
export * from "./ReferencesSection.vue?vue&type=script&lang=js"

import "./ReferencesSection.vue?vue&type=style&index=0&id=0548492d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0548492d"]])

export default __exports__